<gridster [options]="gridsterOptions">
  @for (item of dashboard; track trackByFn($index, item)) {
    <gridster-item [item]="item">
      <div class="gridster-item-wrapper">
        @if (showDragHandle) {
          <div class="item-actions">
            <button
              class="drag-handler"
              nz-button
              nzType="text"
              nzShape="circle"
              type="button"
              title="Drag"
            >
              <span nz-icon nzType="drag" nzTheme="outline"></span>
            </button>
            @if (showEditButton) {
              <button
                nz-button
                nzType="text"
                nzShape="circle"
                class="edit-button"
                type="button"
                (mousedown)="editItem($event, item)"
                (touchstart)="editItem($event, item)"
                title="Edit"
              >
                <span nz-icon nzType="edit" nzTheme="outline"></span>
              </button>
            }
            @if (showRemoveButton) {
              <button
                nz-button
                nzType="text"
                nzDanger
                nzShape="circle"
                class="remove-button"
                type="button"
                (mousedown)="removeItem($event, item)"
                (touchstart)="removeItem($event, item)"
                title="Remove"
              >
                <span nz-icon nzType="delete" nzTheme="outline"></span>
              </button>
            }
          </div>
        }
        <div class="gridster-item-content">
          @if (item.label && !item.hasContent) {
            <div class="widget-label">{{ item.label }}</div>
          }
          <div class="widget-content-area" [attr.data-widget-id]="item.id">
            <!-- محتوای ویجت باید در کامپوننت والد رندر شود -->
            <!-- از widget-content-area با data-widget-id برای استایل استفاده کنید -->
            @if (contentTemplate) {
              <ng-container
                *ngTemplateOutlet="contentTemplate; context: { $implicit: item }"
              ></ng-container>
            }
          </div>
          @if (!item.hasContent && showRemoveButton) {
            <button
              nz-button
              nzType="text"
              nzDanger
              nzShape="circle"
              nzSize="small"
              class="remove-button-small"
              type="button"
              (mousedown)="removeItem($event, item)"
              (touchstart)="removeItem($event, item)"
              title="Remove"
            >
              <span nz-icon nzType="delete" nzTheme="outline"></span>
            </button>
          }
        </div>
      </div>
    </gridster-item>
  }
</gridster>

@if (showAddButton || showSaveButton) {
  <div class="add-button-container">
    @if (showAddButton) {
      <button
        nz-button
        nzType="primary"
        nzShape="circle"
        nzSize="large"
        (click)="addItem()"
        class="add-button"
        type="button"
        title="Add Widget"
      >
        <span nz-icon nzType="plus" nzTheme="outline"></span>
      </button>
    }
    @if (showSaveButton) {
      <button
        nz-button
        nzType="default"
        nzShape="circle"
        nzSize="large"
        [nzLoading]="saveLayoutBusy"
        [disabled]="saveLayoutBusy"
        (click)="saveWidgets()"
        class="save-button"
        type="button"
        title="Save Widgets"
      >
        <span nz-icon nzType="save" nzTheme="outline"></span>
      </button>
    }
  </div>
}
